export default theme => ({
  fadeTransition: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    '&.fadeTransition-enter': {
      opacity: 0
    },
    '&.fadeTransition-enter-active': {
      opacity: 1,
      transition: 'opacity 200ms ease-in'
    },
    '&.fadeTransition-exit': {
      opacity: 1
    },
    '&.fadeTransition-exit-active': {
      opacity: 0,
      transition: 'opacity 200ms ease-in'
    }
  },
  slideDownTransition: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    '&.slideDownTransition-enter': {
      transform: 'translateY(-100%)',
      opacity: 0
    },
    '&.slideDownTransition-enter-active': {
      transform: 'translateY(0%)',
      opacity: 1,
      transition: 'all .3s ease-in-out'
    },
    '&.slideDownTransition-exit': {
      transform: 'translateY(0%)',
      opacity: 1
    },
    '&.slideDownTransition-exit-active': {
      transform: 'translateY(-100%)',
      opacity: 0,
      transition: 'all .3s ease-in-out'
    }
  },
  overflow: {
    overflow: 'hidden'
  }
});